import Vue from 'vue'
import App from './App.vue'
import router from './router'
// 1. 导入 store 的实例对象
import store from './store/store'
// 分页组件
import Pagination from "@/views/component/pagination.vue";
// import { Dialog} from 'element-ui';
// import './assets/font/font.css'
import './assets/font/font.css'
import './assets/css/global.css'
import 'amfe-flexible'
import './utils/rem'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(Dialog)
Vue.component('Pagination', Pagination)
store.dispatch('m_user/GetUrl')
store.dispatch('m_user/GetInfo')
store.dispatch('m_user/GetBottomInfo')
store.dispatch('m_user/GetUserInfo')
Vue.config.productionTip = false
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
